import { useMemo } from 'react';
import { NotesSortingType } from '../enums';
import { TNote } from '../types';

export const useSortNotes = (notes: TNote[], sortingType: NotesSortingType) => {
  const sortedNotes = useMemo(() => {
    if (sortingType === NotesSortingType.CreationDate) {
      return notes.sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );
    }

    if (sortingType === NotesSortingType.DueDate) {
      return notes.sort((a, b) => {
        // Handle notes without due dates - place them at the end
        if (!a.dueDate && !b.dueDate) return 0;
        if (!a.dueDate) return 1;
        if (!b.dueDate) return -1;

        // Both have due dates, sort by date (newest first)
        return new Date(b.dueDate).getTime() - new Date(a.dueDate).getTime();
      });
    }
    return notes;
  }, [notes, sortingType]);

  return sortedNotes;
};
